import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { COSIGN_TOKEN_KEY, COSIGN_X_PLATFORM_TOKEN } from '@constants'
import { useApiMutationCosignToken } from '@hooks-api/fortune/refreshCosignToken'
import { useApiTokenLogin } from '@hooks-api/fortune/useApiTokenLogin'
import { Button } from '@pets-ui/Button/Button'
import { NoticeOutlined } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'
import queryString from 'query-string'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom-v5'
import { getClient } from '../../clients'
import Loading from '../../components/loading'

export function CampaignAuthProcessing() {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { search } = useLocation()
  const history = useHistory()
  const queryParams = queryString.parse(search)
  const { trigger: mutateCosignToken } = useApiMutationCosignToken({ code: campaignCodeFromUrl })
  const { isLoading: isTokenLoginLoading, destructuredData: tokenLoginData } = useApiTokenLogin(queryParams.token
    ? {
      campaign_code: campaignCodeFromUrl,
      cosign_token: queryParams.token as string,
    }
    : undefined, {
    onErrorRetry: (error) => {
      // NOTE: Never retry on 403.
      if (error.status === 403) return null
    },
  })

  useEffect(() => {
    if (!tokenLoginData || !queryParams.token) return
    const handleTokenLogin = async () => {
      const cosignToken = tokenLoginData?.access_token
      Cookies.set(`${campaignCodeFromUrl}_${COSIGN_TOKEN_KEY}`, cosignToken)
      getClient('fortune').defaults.headers['access-token'] = cosignToken
      getClient('butler').defaults.headers.Authorization = `Bearer ${cosignToken}`
      const jwtPayload = jwtDecode<{ redirectUrl?: string }>(queryParams.token as string)
      try {
        const { data: { data: { x_platform_token } } } = await mutateCosignToken({ code: campaignCodeFromUrl })
        Cookies.set(`${campaignCodeFromUrl}_${COSIGN_X_PLATFORM_TOKEN}`, x_platform_token)
      }
      catch (error) {
        console.error(error)
      }
      if (!tokenLoginData.is_verified) {
        window.location.href = `${window.location.origin}/campaigns/${campaignCodeFromUrl}/group-buying`
      }
      else {
        window.location.href = jwtPayload.redirectUrl ?? `${window.location.origin}/campaigns/${campaignCodeFromUrl}`
      }
    }
    handleTokenLogin()
  }, [campaignCodeFromUrl, mutateCosignToken, queryParams.token, tokenLoginData])

  if (isTokenLoginLoading || tokenLoginData) {
    return <Loading />
  }

  const handleClickBack = () => {
    history.push(`/campaigns/${campaignCodeFromUrl}/login`)
  }

  return (
    <VStack gap={5} paddingTop="212px" alignItems="center" justifyContent="center">
      <NoticeOutlined color={colors.red600} fontSize="80px" />
      <Text variant="h4">權限不足，無法登入</Text>
      <Button width="350px" onClick={handleClickBack}>返回登入頁</Button>
    </VStack>
  )
}
